import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ParallaxProvider } from 'react-scroll-parallax';
import { Toaster } from 'react-hot-toast';
import App from './App.jsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ParallaxProvider>
            <BrowserRouter>
                <App />
                <Toaster position="top-center" />
            </BrowserRouter>
        </ParallaxProvider>
    </React.StrictMode>
);
